import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { UserPrivilegeEnum } from '../../../../enums/rights/user-privilege.enum';
import { ResetStateDefaults } from '../../../base-action-class.model';
import { RWorkOrder } from './r-work-order.action';

interface RWorkOrderXsStateModel {
  createWorkOrder: string;
  editWorkOrder: string;
  deleteWorkOrder: string;
}

const getDefaults = () : RWorkOrderXsStateModel => ({
  createWorkOrder: null,
  editWorkOrder: null,
  deleteWorkOrder: null,
});

@State<RWorkOrderXsStateModel>({
  name:       'rWorkOrder',
  defaults:   getDefaults()
})
@Injectable()
export class RWorkOrderXsState {

  //region SELECTOR
  @Selector()
  static canCreateWorkOrder(state: RWorkOrderXsStateModel) : boolean {
    return state.createWorkOrder != null;
  }

  @Selector()
  static canEditWorkOrder(state: RWorkOrderXsStateModel) : boolean {
    return state.editWorkOrder != null;
  }

  @Selector()
  static canDeleteWorkOrder(state: RWorkOrderXsStateModel) : boolean {
    return state.deleteWorkOrder != null;
  }
  //endregion

  //region ACTIONS
  @Action(RWorkOrder.SetWorkOrderPrivileges)
  public setWorkOrderPrivileges(ctx: StateContext<RWorkOrderXsStateModel>, action: RWorkOrder.SetWorkOrderPrivileges) {
    const state = ctx.getState();
    const workOrderPrivileges: string[] = [...action.activeUserRightInfoDtoModel.workOrderPrivileges];

    //find user privilege data model
    const createWorkOrder: string
      = workOrderPrivileges.find(id => id === UserPrivilegeEnum.CREATE_WORK_ORDER);
    const editWorkOrder: string
      = workOrderPrivileges.find(id => id === UserPrivilegeEnum.EDIT_WORK_ORDER);
    const deleteWorkOrder: string
      = workOrderPrivileges.find(id => id === UserPrivilegeEnum.DELETE_WORK_ORDER);

    //set the state
    ctx.setState({
      ...state,
      createWorkOrder,
      editWorkOrder,
      deleteWorkOrder
    });

  }

  @Action(ResetStateDefaults)
  public resetDefaults(ctx: StateContext<RWorkOrderXsStateModel>): void {
    ctx.setState({...getDefaults()});
  }
  //endregion

}
